module.exports = {
  RoleType: {
    super: 0,
    admin: 1,
    scheduler: 2,
    follower: 3,
    streamer_admin: 4,
    follower_admin: 5,
    treasurer: 6,
    business: 7,
    buyer: 8
  },
  RoleName: {
    0: "超级管理员",
    1: "管理员",
    2: "AE",
    3: "跟播",
    4: "主播管理",
    5: "跟播管理",
    6: "财务",
    7: "商务",
    8: "采购"
  },

  AnalyseFieldList: [
    {
      title: "单场分析",
      fields: [
        ["view_cnt", "观看次数"],
        ["uv", "UV"],
        ["add_fans", "新增粉丝数"],
        ["product_click_user", "商品点击人数"],
        ["order_user", "引导成交人数"],
        ["order_amount", "引导成交金额"],
        ["estimated_presale_final_amount", "预售预估总金额"],
        ["presale_front_amount", "预售定金金额"],
        ["analyse_add_fans", "每小时增粉"],
        ["analyse_product_click_user", "每小时进店率"],
        ["analyse_order_user", "引导成交率"],
        ["analyse_streamer_price", "主播单价"],
        ["analyse_streamer_total_price", "主播总价"],
        ["analyse_order_amount", "直播ROI"]
      ]
    },
    {
      title: "主播榜单",
      fields: [
        ["analyse_add_fans", "每小时增粉"],
        ["analyse_product_click_user", "每小时进店率"],
        ["analyse_order_user", "引导成交率"],
        ["analyse_order_amount", "直播ROI"]
      ]
    }
  ],
  ReportFieldList3: [
    {
      title: "小程序",
      fields: [
        ["title", "标题"],
        ["onlineUv", "实时在线人数"],
        ["watchUv", "观看人数"],
        ["watchPv", "观看次数"],
        ["averageWatchTime", "平均观看时长(秒)"],
        ["pushCnt", "累积推送次数"],
        ["clickUv", "商品点击人数"],
        ["clickPv", "商品点击次数"],
        ["likeUv", "点赞人数"],
        ["likePv", "点赞次数"],
        ["commentUv", "评论人数"],
        ["commentPv", "评论次数"],
        ["shareUv", "分享人数"],
        ["sharePv", "分享次数"],
        ["subscribeUv", "单次订阅人数"],
        ["followerNum", "累计长期订阅人数"],
        ["观看人次", "观看人次"],
        ["观看人数", "观看人数"],
        ["直播引流PV", "直播引流PV"],
        ["直播引流UV", "直播引流UV"],
        ["下单人数", "下单人数"],
        ["下单订单数", "下单订单数"],
        ["下单金额", "下单金额"],
        ["下单客单价", "下单客单价"],
        ["成交人数", "成交人数"],
        ["成交订单数", "成交订单数"],
        ["成交金额", "成交金额"],
        ["成交客单价", "成交客单价"]
      ]
    },
    {
      title: "快手后台",
      fields: [
        ["title", "标题"],
        ["实时观看人数", "实时观看人数"],
        ["平均在线人数", "平均在线人数"],
        ["离开直播间人数", "离开直播间人数"],
        ["进入直播间人数", "进入直播间人数"],
        ["上车商品数", "上车商品数"],
        ["商品下单量", "商品下单量"],
        ["商品成交件数", "商品成交件数"],
        ["商品成交金额", "商品成交金额"],
        ["商品支付人数", "商品支付人数"],
        ["讲解卡片成交件数", "讲解卡片成交件数"],
        ["讲解卡片成交占比", "讲解卡片成交占比"],
        ["讲解卡片成交订单量", "讲解卡片成交订单量"],
        ["讲解卡片成交金额", "讲解卡片成交金额"],
        ["退款金额", "退款金额"],
        ["UV价值", "UV价值"],
        ["orderGmv", "订单GMV"],
        ["人均观看时长", "人均观看时长"],
        ["单位观看时长成交金额", "单位观看时长成交金额"],
        ["客单价", "客单价"],
        ["支付转化率", "支付转化率"],
        ["曝光点击率", "曝光点击率"],
        ["次均观看时长", "次均观看时长"],
        ["直播曝光次数", "直播曝光次数"],
        ["粉丝成交占比", "粉丝成交占比"],
        ["累计成交订单量", "累计成交订单量"],
        ["累计观看人数", "累计观看人数"],
        ["退款金额", "退款金额"],
        ["投放引导下单量", "投放引导下单量"],
        ["投放引导成交金额", "投放引导成交金额"],
        ["投放引导涨粉数量", "投放引导涨粉数量"],
        ["投放引导观看次数", "投放引导观看次数"],
        ["直播期间投放ROI", "直播期间投放ROI"],
        ["直播期间投放金额", "直播期间投放金额"],
        ["川流计划引导成交支付金额", "川流计划引导成交支付金额"],
        ["川流计划引导涨粉数", "川流计划引导涨粉数"],
        ["川流计划引导观看次数", "川流计划引导观看次数"],
        ["川流计划引导订单量", "川流计划引导订单量"],
        ["川流计划曝光次数", "川流计划曝光次数"],
        ["新增粉丝数", "新增粉丝数"],
        ["粉丝复购率", "粉丝复购率"],
        ["累计买家数", "累计买家数"],
        ["累计观看人数", "累计观看人数"],
        ["上架商品数", "上架商品数"],
        ["人均观看时长", "人均观看时长"],
        ["商品点击人数", "商品点击人数"],
        ["实时在线观看人数", "实时在线观看人数"],
        ["小黄车点击数", "小黄车点击数"],
        ["成交转化率", "成交转化率"],
        ["打赏数", "打赏数"],
        ["新增粉丝数", "新增粉丝数"],
        ["点赞数", "点赞数"],
        ["粉丝平均观看时长", "粉丝平均观看时长"],
        ["累计成交人数", "累计成交人数"],
        ["累计成交订单数", "累计成交订单数"],
        ["累计成交金额", "累计成交金额"],
        ["观看人数", "观看人数"],
        ["观看次数", "观看次数"],
        ["人均观看时长", "人均观看时长"],
        ["千次观看成交金额", "千次观看成交金额"],
        ["成交订单数", "成交订单数"],
        ["成交转化率", "成交转化率"],
        ["成交金额", "成交金额"],
        ["新增粉丝数", "新增粉丝数"],
        ["累计观看人数", "累计观看人数"],
        ["累计评论数", "累计评论数"],
        ["讲解卡成交占比", "讲解卡成交占比"],
        ["讲解卡成交金额", "讲解卡成交金额"]
      ]
    },
    {
      title: "美团后台",
      fields: [
        ["title", "标题"],
        ["curOnlinePeopleNum", "当前在线人数"],
        ["exposureCount", "累计观看次数"],
        ["highestOnlinePeopleNum", "最高在线人数"],
        ["interactionRate", "观看-互动率(人数)", "%"],
        ["interactionRateWithoutShelf", "观看互动率(人数)(不含货架)", "%"],
        ["newFans", "新增粉丝数"],
        ["orderAmount", "订单成交金额", "/10000"],
        ["orderNum", "下单订单数"],
        ["orderUserCount", "下单人数"],
        ["perAvgViewTime", "人均观看时长"],
        ["perMinOnlinePeopleNum", "每分钟在线人数"],
        ["perThousandViewAmount", "千次观看成交金额", "/100"],
        ["shareUserCount", "分享人数"],
        ["skuClickRatio", "商品点击率(次数)", "%"],
        ["skuOrderRatio", "商品下单率(次数)", "%"],
        ["totalOnlinePeopleNum", "累计观看人数"],
        ["watchFollowRate", "观看-关注率(人数)", "%"],
        ["watchOrderRate", "观看-下单率(人数)", "%"]
      ]
    },
    {
      title: "新版京东后台",
      fields: [
        ["title", "标题"],
        ["onlineUv", "当前在线人数"],
        ["dealAmt", "累计成交金额"],
        ["dealSaleQtty", "成交件数"],
        ["dealParent", "成交父单量"],
        ["dealSaleRate", "成交转化率"],
        ["uvValue", "UV价值"],
        ["uv", "访问人数"],
        ["pv", "访问人次"],
        ["clickExposureRate", "曝光点击率"],
        ["quotationRate", "引商率"],
        ["stayTime", "人均停留时长"],
        ["newFans", "新增粉丝数"],
        ["commentPv", "评论次数"],
        ["likePv", "点赞次数"],
        ["sharePv", "分享次数"],
        ["fanVisits", "粉丝访问占比"],
        ["fanTransactions", "粉丝成交占比"],
        ["dealSaleUv", "成交人数"],
        ["gpm", "GPM"],
        ["quotationUv", "引商人数"],
        ["dealChild", "成交子单量"],
        ["depositUserSum", "定金人数"],
        ["depositAmtSum", "定金金额"],
        ["finalAmtSum", "预估尾款金额"],
        ["ordQttySum", "定金件数"]
      ]
    }
  ],
  ReportFieldList2: [
    {
      title: "抖音后台",
      fields: [
        ["title", "标题"],
        // 直播大屏core_data
        ["dy_online_user_cnt", "平均在线人数"],
        ["dy_live_show_watch_cnt_ratio", "曝光-观看率(次数)", "%"],
        ["dy_watch_interact_ucnt_ratio", "观看-互动率(人数)", "%"],
        ["dy_follow_anchor_ucnt", "新增粉丝数"],
        ["dy_watch_ucnt", "累计观看人数"],
        ["dy_live_show_cnt", "曝光次数"],
        ["dy_avg_watch_duration", "人均观看时长(秒)"],
        ["dy_avg_min_comment_cnt", "平均评论次数(分钟)"],
        ["dy_watch_follow_ucnt_ratio", "观看-关注率(人数)", "%"],
        ["dy_fans_club_join_ucnt", "新加直播团人数"],
        ["dy_watch_fans_club_join_ucnt_ratio", "观看-加直播团率(人数)", "%"],
        ["dy_incr_ecf_club_ucnt", "新加购物团人数"],
        ["dy_incr_ecf_club_ucnt_ratio", "观看-加购物团率(人数)", "%"],
        ["dy_pay_ucnt", "成交人数"],
        ["dy_gpm", "千次观看成交金额", "/100"],
        ["dy_watch_pay_ucnt_ratio", "观看-成交率(人数)", "%"],
        ["dy_product_click_pay_ucnt_ratio", "商品点击-成交率(人数)", "%"],
        ["dy_real_refund_amt", "退款金额", "/100"],
        ["dy_real_refund_amt_ratio", "退款金额占比"],
        ["dy_pay_deposit_pre_order_amt", "预售全款金额", "/100"],
        ["dy_pay_combo_cnt", "成交件数"],
        ["dy_old_fans_pay_ucnt_ratio", "成交老粉占比"],
        ["dy_stat_cost", "千川消耗", "/100"],
        ["dy_livetoind_pay_amt", "指示器成交金额", "/100"],
        ["dy_punish_cnt", "违规次数"],

        // 这里字段名字还需要再确认一下
        // 巨量千川
        ["dy_totalLiveAcu", "平均在线人数"],
        ["dy_totalLivePayOrderGmv", "累计成交金额(元)", "/100000"],
        ["dy_totalLivePayOrderGpmEcom", "GPM"],
        ["dy_watchPayUcntRatio", "观看-成交转化率", "%1"],
        ["dy_totalLiveDurationAvgEcom", "平均停留时长(秒)", "f2"],
        ["dy_adLivePayOrderGmvRoi", "广告ROI"],
        ["dy_adLivePayOrderRate", "广告支付转化率", "%1"],
        ["dy_ctr", "广告点击率", "%1"],
        ["dy_liveOrderPayCouponAmount", "成交智能优惠券金额(元)", "/10000"],
        ["dy_livePayOrderGmvRoi", "整体ROI", "f2"],
        ["dy_lubanLivePayOrderGmv", "广告成交金额", "/10000"],
        ["dy_lubanLivePayOrderGpm", "广告GPM", "/100000"],
        ["dy_statCost", "广告消耗", "/10000"],

        ["dy_traffic_source_from_pay", "流量来源-付费流量", "%1"],
        ["dy_traffic_invert_ad_cvr", "流量转化-广告CVR", "%1"],
        ["dy_traffic_invert_nature_cvr", "流量转化-自然流CVR", "%1"],

        // 直播间详情
        ["dy_baoguang_number", "直播间曝光人数", "int"],
        ["dy_max_online_number", "最高在线人数"],
        ["dy_dianzan_count", "点赞次数"],
        ["dy_comment_count", "评论次数"],
        ["dy_goods_click_count", "商品点击人数"],
        ["dy_live_goods_click_rate", "直播间商品曝光-点击率(人数)", "%1"],
        ["dy_price_per_customer", "客单价"]
      ]
    }
  ],
  ReportFieldList: [
    {
      title: "中控台数据",
      fields: [
        ["tb_live_id", "淘宝直播ID"],
        ["title", "标题"],
        ["view_cnt", "浏览次数"],
        ["start_viewer", "在线人数(开)"],
        ["end_viewer", "在线人数(下)"],
        ["max_viewer", "在线人数(最高)"],
        ["avg_view_time", "平均观看时长(秒)"],
        ["title_page_ctr", "封面图点击率"],
        ["pv", "观看次数（PV）"],
        ["uv", "观看人数（UV）"],
        ["extra_view_cnt", "额外奖励流量"],
        ["add_fans", "新增粉丝数"],
        ["product_click_user", "商品点击人数"],
        ["product_click", "商品点击次数"],
        ["product_ctr", "商品点击率"],
        ["order_user", "引导成交人数"],
        ["order_amount", "引导成交金额"],
        ["order_product_num", "引导成交件数"],
        ["estimated_presale_final_amount", "预售预估总金额"],
        ["order_rate", "引导成交转化率"],
        ["presale_front_amount", "预售定金金额"],
        ["live_flow_score_level", "实时流量竞争力评级"],
        ["trd_score", "实时推荐流量交易指数"],
        ["popularity_score", "实时推荐流量内容指数"],
        ["top_product", "点击率前三商品"]
      ]
    },
    {
      title: "京东后台",
      fields: [
        ["title", "标题"],
        ["jd_deal_total", "成交金额"],
        ["jd_sales_total", "成交件数"],
        ["jd_deal_sale_rate", "成交转化率"],
        ["jd_click_exposure_rate", "曝光点击率"],
        ["jd_follow_num", "新增粉丝数"],
        ["jd_uv", "访问人数"],
        ["jd_pv", "访问人次"],
        ["jd_stay_time", "人均停留时长"],
        ["jd_thumb_num", "点赞数"],
        ["jd_comment_num", "评论数"],
        ["top_product", "点击率前三商品"]
      ]
    },
    {
      title: "抖音后台",
      fields: [
        ["title", "标题"],
        ["dy_online_user_cnt", "观看人数"],
        ["dy_watch_uv", "观看次数"],
        ["dy_max_viewer", "最高在线人数"],
        ["dy_pay_cnt", "成交人数"],
        ["dy_incr_fans_cnt", "新增粉丝数"],
        ["dy_comment_num", "点赞数"],
        ["dy_comment_num", "评论数"],
        ["dy_show_uv", "商品曝光"],
        ["dy_click_uv", "点击人数"],
        ["dy_pay_in_live_num", "订单数"],
        ["dy_pay_in_live_gmv", "GMV销售额"],
        ["dy_cost", "投放金额"],
        ["dy_convert_distribution", "投放流量"],
        ["dy_luban_live_pay_order_gmv", "投放转化金额"],
        // 以下是旧版本数据
        ["dy_accumulative_watch_times", "直播间观看人次（旧版数据）"],
        ["dy_created_order_num", "创建订单数（旧版数据）"],
        ["dy_created_gmv", "创建订单金额（旧版数据）"],
        ["dy_pay_order_num", "成交订单数（旧版数据）"],
        ["dy_pay_gmv", "成交金额（旧版数据）"],
        ["dy_order_pay_ratio", "订单付款率（旧版数据）"]
      ]
    },
    {
      title: "生意参谋",
      fields: [
        ["shop_uv", "引导进店UV"],
        ["shop_fans_uv", "引导粉丝进店UV"],
        ["shop_order_cnt", "转化笔数"],
        ["shop_fans_order_cnt", "粉丝转化笔数"],
        ["shop_order_amount", "转化金额"],
        ["shop_fans_order_amount", "粉丝转化金额"]
      ]
    },
    {
      title: "存档",
      fields: [
        ["replay_url", "直播视频回放"],
        ["follower_remark_info", "跟播备注"],
        ["tb_live_screen_shot", "中控台截图"],
        ["streamer_screen_shot", "讲解主播截图"],
        ["product_click_screen_shot", "商品点击截图"],
        ["billboard_screen_shot", "榜单截图"]
      ]
    },
    {
      title: "运营备注",
      fields: [
        ["live_activity", "店铺活动"],
        ["live_resource", "资源位"],
        ["live_activity_remark", "活动备注"],
        ["live_summary", "直播总结"]
      ]
    }
  ],
  // 弃用，旧版本类型
  CompanyStaffType: {
    "1": "短视频",
    "2": "文案策划",
    "3": "商务",
    "4": "AE"
  },
  CompanyAccountingType: {
    "1": "费用项",
    "2": "费用(报价)项"
  },
  BrandType: {
    "1": "淘宝直播",
    "2": "京东直播",
    "3": "抖音直播",
    "4": "PGC",
    "6": "快手直播",
    "5": "小程序",
    "7": "美团直播",
    "8": "京东直播"
  },
  PGCBandType: {
    "1": "淘宝直播",
    "2": "京东直播",
    "3": "抖音直播",
    "4": "小程序"
  },
  PGCStudioType: {
    "1": "公司",
    "2": "外场"
  },
  SupplierStatusOptions: [
    {
      label: "正常",
      value: 0
    },
    {
      label: "停用",
      value: 1
    },
    {
      label: "待审核",
      value: 2
    }
  ],
  SupplierServiceOptions: [
    {
      label: "设计类",
      value: "设计类"
    },
    {
      label: "制作团队",
      value: "制作团队"
    },
    {
      label: "策划",
      value: "策划"
    },
    {
      label: "图文",
      value: "图文"
    },
    {
      label: "短视频",
      value: "短视频"
    },
    {
      label: "直播影棚",
      value: "直播影棚"
    },
    {
      label: "场景搭建",
      value: "场景搭建"
    },
    {
      label: "明星经纪",
      value: "明星经纪"
    },
    {
      label: "红人经纪",
      value: "红人经纪"
    },
    {
      label: "妆发造型",
      value: "妆发造型"
    },
    {
      label: "明星商务茶歇采买对接",
      value: "明星商务茶歇采买对接"
    }
  ],
  SupplierOfferType: {
    场地: 1,
    摄制人员: 2,
    摄制器材: 3,
    内容: 4,
    置景: 5,
    差旅: 6,
    嘉宾模特等人员: 7
  },
  ProjectStatusOptions: [
    {
      label: "报价中（未审核）",
      value: 0
    },
    {
      label: "报价中（采购已审核，财务未审核）",
      value: 1
    },
    {
      label: "报价中（财务已审核，采购未审核）",
      value: 2
    },
    {
      label: "报价中（已审核）",
      value: 3
    },
    {
      label: "进行中",
      value: 4
    },
    {
      label: "已结束（品牌未结算）",
      value: 5
    },
    {
      label: "已结束（品牌已结算）",
      value: 6
    },
    {
      label: "已完成",
      value: 7
    },
    {
      label: "已取消（待审核）",
      value: 8
    },
    {
      label: "已取消",
      value: 9
    }
  ],
  ProjectStatusName: {
    0: "报价中（未审核）",
    1: "报价中（采购已审核，财务未审核）",
    2: "报价中（财务已审核，采购未审核）",
    3: "报价中（已审核）",
    4: "进行中",
    5: "已结束（品牌未结算）",
    6: "已结束（品牌已结算）",
    7: "已完成",
    8: "已取消（待审核）",
    9: "已取消"
  },
  ProjectTypeOptions: [
    {
      label: "单机位（Ｓ）",
      value: 1
    },
    {
      label: "双机位（Ｄ）",
      value: 2
    },
    {
      label: "明星（Ａ）",
      value: 3
    }
  ],
  ProjectTypeMap: {
    0: "未知",
    1: "单机位（Ｓ）",
    2: "双机位（Ｄ）",
    3: "明星（Ａ）"
  },
  ProjectCoTypeOptions: [
    {
      label: "年框",
      value: 0
    },
    {
      label: "非年框",
      value: 1
    },
    {
      label: "自定义",
      value: 2
    }
  ],
  ProjectCoTypeMap: {
    0: "年框",
    1: "非年框",
    2: "自定义"
  },
  ProjectCostItemTypeOptions: [
    {
      label: "摄制人员",
      value: 101
    },
    {
      label: "供应商成本",
      value: 102
    },
    {
      label: "内容",
      value: 103
    },
    {
      label: "杂费",
      value: 104
    }
  ],
  ProjectCostItemTypeMap: {
    101: "摄制人员",
    102: "供应商成本",
    103: "内容",
    104: "杂费"
  },
  ProjectItemTypeOptions: [
    {
      label: "场地",
      value: 1
    },
    {
      label: "摄制人员",
      value: 2
    },
    {
      label: "摄制器材",
      value: 3
    },
    {
      label: "内容",
      value: 4
    },
    {
      label: "置景",
      value: 5
    },
    {
      label: "差旅",
      value: 6
    },
    {
      label: "嘉宾模特等人员",
      value: 7
    }
  ],
  ProjectItemTypeMap: {
    1: "场地",
    2: "摄制人员",
    3: "摄制器材",
    4: "内容",
    5: "置景",
    6: "差旅",
    7: "嘉宾模特等人员"
  },
  ProjectCustomItemStatusMap: {
    0: "未审核",
    1: "采购已审核，财务未审核",
    2: "财务已审核，采购未审核",
    3: "已审核"
  },
  ProjectItemKOLTypeOptions: [
    {
      label: "明星",
      value: 0
    },
    {
      label: "总裁",
      value: 1
    },
    {
      label: "非明星",
      value: 2
    }
  ],
  // 供应商套餐
  SupplierOfferSetType: {
    不选套餐: 0,
    S: 1,
    A: 2,
    B: 3,
    O: 4
  },
  // 场地+供应商模式对应套餐
  SupplierOfferSetSITMap: {
    SIT00102: { 不选套餐: 0, A: 2, B: 3 },
    SIT00201: { 不选套餐: 0, S: 1, A: 2, O: 4 },
    SIT00202: { 不选套餐: 0, S: 1, O: 4 },
    SIT00301: { 不选套餐: 0, O: 4 },
    SIT00302: { 不选套餐: 0, O: 4 }
  },
  // 审核过后还可以编辑的项目
  SupplierOfferEditFree: ["SET00201", "SET00301", "TRA00101", "TRA00102"],
  // 不可编辑成本的项目
  SupplierOfferUneditableCost: [
    "SIT00102",
    "SIT00201",
    "CRE00101",
    "CRE00102",
    "CRE00103",
    "CRE00201",
    "CRE00202",
    "CRE00203",
    "CRE00302",
    "EQU00203",
    "EQU00401",
    "EQU00502",
    "EQU00603",
    "EQU00702",
    "CON00101",
    "CON00102",
    "CON00103",
    "CON00104",
    "CON00105",
    "CON00106",
    "CON00201",
    "CON00202",
    "CON00203",
    "CON00204",
    "SET00101",
    "CAS00102"
  ],
  // 包含供应商选项的项目
  SupplierOfferNeedSupplier: [
    "CRE003",
    "CRE004",
    "CRE005",
    "CRE006",
    "CRE007",
    "EQU001",
    "EQU002",
    "EQU003",
    "EQU004",
    "EQU005",
    "EQU006",
    "EQU007",
    "EQU008",
    "EQU009",
    "EQU010",
    "EQU010"
  ],
  // 和机位关联的项目
  SupplierOfferDefaultNum: [
    "CRE00401",
    "CRE00402",
    "CRE00403",
    "EQU00201",
    "EQU00203"
  ],
  // 可重复选择工作人员类型
  SupplierOfferStaffMultiSelect: [
    "CON00101",
    "CON00102",
    "CON00103",
    "CON00104",
    "CON00105",
    "CON00106",
    "CON00201",
    "CON00202",
    "CON00203",
    "CON00204"
  ],
  // 可添加工作人员类型
  SupplierOfferStaffTypeMap: {
    CRE00101: [],
    CRE00102: [5],
    CRE00103: [5],
    CRE00201: [2, 4],
    CRE00202: [2],
    CRE00203: [4],
    CRE00302: [1, 7],
    CRE00502: [1, 7],
    CRE00602: [1, 7],
    CRE00403: [1, 4, 8],
    CRE00702: [4, 8],
    CRE00801: [8],
    CRE00901: [],
    CRE01001: [9],
    CRE01101: [10],
    CRE01201: [11],
    CRE01301: [12],
    CON00101: [2],
    CON00102: [2],
    CON00103: [2],
    CON00104: [2],
    CON00105: [2],
    CON00106: [2],
    CON00201: [2],
    CON00202: [2],
    CON00203: [2],
    CON00204: [2]
  },
  SupplierOfferStaffTypeSpecialMap: {
    CRE00101: [],
    CRE00102: [3, 5],
    CRE00103: [3, 5],
    CRE00201: [2, 4],
    CRE00202: [2],
    CRE00203: [4],
    CRE00302: [1, 7],
    CRE00502: [1, 7],
    CRE00602: [1, 7],
    CRE00403: [1, 4, 8],
    CRE00702: [4, 8],
    CRE00801: [8],
    CRE00901: [],
    CRE01001: [9],
    CRE01101: [10],
    CRE01201: [11],
    CRE01301: [12],
    CON00101: [2],
    CON00102: [2],
    CON00103: [2],
    CON00104: [2],
    CON00105: [2],
    CON00106: [2],
    CON00201: [2],
    CON00202: [2],
    CON00203: [2],
    CON00204: [2]
  },
  // 次级选项
  // multi 表示比如 CRE001 的多个选项可以多选
  // multiple 表示比如 CRE001 的选项中的每一项可以选多次
  SupplierOfferSubList: {
    2: [
      { label: "项目统筹", key: "CRE001", multi: false, multiple: false },
      { label: "现场导播", key: "CRE002", multi: false, multiple: false },
      { label: "技术导演", key: "CRE003", multi: false, multiple: false },
      { label: "摄像师", key: "CRE004", multi: true, multiple: true },
      { label: "灯光师", key: "CRE005", multi: true, multiple: true },
      { label: "调音师", key: "CRE006", multi: true, multiple: true },
      { label: "推流师", key: "CRE007", multi: true, multiple: true },
      { label: "中控", key: "CRE008", multi: true, multiple: true },
      { label: "网络技术工程师", key: "CRE009", multi: true, multiple: true },
      { label: "场务", key: "CRE010", multi: true, multiple: true },
      { label: "题词", key: "CRE011", multi: true, multiple: true },
      { label: "明星接待", key: "CRE012", multi: true, multiple: true },
      { label: "视频组", key: "CRE013", multi: true, multiple: true }
    ],
    3: [
      { label: "导播台", key: "EQU001", multi: false, multiple: false },
      { label: "摄像设备", key: "EQU002", multi: false, multiple: false },
      { label: "辅助摄像", key: "EQU003", multi: true, multiple: false },
      { label: "视频采集", key: "EQU004", multi: true, multiple: false },
      { label: "灯光设备组", key: "EQU005", multi: false, multiple: false },
      { label: "收音设备", key: "EQU006", multi: true, multiple: false },
      { label: "推流设备", key: "EQU007", multi: false, multiple: false },
      { label: "输出设备", key: "EQU008", multi: true, multiple: false },
      { label: "达芬奇调色", key: "EQU009", multi: true, multiple: false },
      { label: "网络设备", key: "EQU010", multi: true, multiple: false }
    ],
    4: [
      { label: "内容策划", key: "CON001", multi: true, multiple: false },
      { label: "素材制作", key: "CON002", multi: true, multiple: false }
    ],
    5: [
      { label: "直播背景", key: "SET001", multi: true, multiple: false },
      { label: "背景道具运输", key: "SET002", multi: true, multiple: false },
      { label: "其他增项费用", key: "SET003", multi: true, multiple: false }
    ],
    6: [
      { label: "员工/嘉宾差旅", key: "TRA001", multi: true, multiple: false }
    ],
    7: [{ label: "嘉宾/模特", key: "CAS001", multi: true, multiple: false }]
  },
  ProjectCostV3Types: {
    垫付: [],
    提成: [
      "品牌商务",
      "项目统筹",
      "AE",
      // "摄像",
      // "导播",
      "执行导演",
      "题词",
      "方案费",
      "脚本费",
      "跟播助理",
      "场务",
      "短视频",
      "明星接待"
    ],
    // 主播费用: [],
    餐费: [],
    差旅费: [],
    样品支出: [],
    非供应商物料费: [],
    非供应商场地费用: [],
    嘉宾及主持人费用: [],
    技术供应商费用: [],
    搭建供应商费用: [],
    物料供应商费用: [],
    场地供应商费用: [],
    其他供应商费用: [],
    公司成本计提: [
      // "设计成本计提",
      // "职能部门成本计提",
      // "提成计提",
      // "策划基础成本计提",
      // "AE基础成本计提",
      // "公司管理成本计提",
      // "直播间成本",
      "5F空调加时费",
      "设备租用成本"
    ]
  },
  SupplierServices: {
    技术供应商费用: ["短视频", "制作团队"],
    搭建供应商费用: ["场景搭建"],
    物料供应商费用: ["设计类", "策划", "图文"],
    场地供应商费用: ["直播影棚"],
    其他供应商费用: ["明星商务茶歇采买对接", "明星经纪", "红人经纪", "妆发造型"]
  },
  StaffType: {
    短视频: 1,
    策划: 2,
    "商务统筹（品牌部）": 3,
    AE: 4,
    "商务统筹（PGC组）": 5,
    现场编导: 6,
    技术导演: 7,
    "跟播/助理": 8,
    场务: 9,
    题词: 10,
    明星接待: 11,
    视频组: 12,
    高级导播: 13,
    "商务统筹A级（代播）": 14,
    "商务统筹A级（PGC组）": 15,
    高级AE: 16,
    "执行AE（PGC)": 17,
    "高级AE(PGC)": 18
  },
  StaffTypeName: {
    1: "短视频",
    2: "策划",
    3: "商务统筹（代播）",
    4: "执行AE (代播)",
    5: "商务统筹（PGC组）",
    6: "摄像",
    7: "导播",
    8: "跟播/助理",
    9: "场务",
    10: "题词",
    11: "明星接待",
    12: "视频组",
    13: "高级导播",
    14: "商务统筹A级（代播）",
    15: "商务统筹A级（PGC组）",
    16: "高级AE (代播)",
    17: "执行AE（PGC)",
    18: "高级AE(PGC)"
  },
  CostStaffTypes: {
    品牌商务: [3, 5, 14, 15],
    项目统筹: [3, 5, 14, 15],
    AE: [4, 16, 17, 18],
    摄像: [6],
    导播: [7, 13],
    执行导演: [2, 4, 16, 17, 18],
    // 题词: [], 所有人
    方案费: [2],
    脚本费: [2],
    跟播助理: [8],
    // 场务: [], 所有人
    短视频: [1, 2, 12]
  },
  CostStaffSelect: {
    摄像: [0, 100, 200], // 排期中填写
    导播: [0, 200, 400], // 排期中填写
    执行导演: [0, 300, 500]
    // 题词: [0, 100, 200],
    // 方案费: [0, 300, 400, 500, 1000],
    // 脚本费: [0, 500, 1000],
    // 场务: [0, 100, 200],
    // 明星接待: [0, 100, 200]
  }
};



// WEBPACK FOOTER //
// ./src/common/common.js